import type { RouteConfig } from "@/types/routestypes";
import { lazy } from "react";

const RosterPlan = lazy(() => import("@/pages/RosterPlan/RosterPlanPage"));

const RosterPlanRoute: RouteConfig = {
    path: "/rosterplan",
    element: <RosterPlan />,
    pageName: "Roster Plan",
    sidebar: { show: true, icon: "/assets/media/rosterLogo.svg" },
    permission: ["ManageRoles"]
}

export default RosterPlanRoute

